export default function initMegaMenu() {
    const trigger = document.getElementById('mega-menu-trigger');
    const panel = document.getElementById('mega-menu');

    if (!trigger || !panel) return;

    let closeTimer = null;

    // -------------------------------------------------------
    // Desktop: hover open/close
    // -------------------------------------------------------
    const open = () => {
        clearTimeout(closeTimer);
        panel.classList.add('is-open');
        trigger.classList.add('is-active');
    };

    const close = () => {
        closeTimer = setTimeout(() => {
            panel.classList.remove('is-open');
            trigger.classList.remove('is-active');
        }, 350);
    };

    const closeImmediately = () => {
        clearTimeout(closeTimer);
        panel.classList.remove('is-open');
        trigger.classList.remove('is-active');
    };

    trigger.addEventListener('mouseenter', open);
    trigger.addEventListener('mouseleave', close);
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', close);

    // Close instantly when the user moves to another top-level nav item that
    // has its own dropdown — query while subnavs are still in the DOM
    // (before initSubnav moves them to <body>).
    document.querySelectorAll('.header__wrap__menu__item').forEach(item => {
        if (item === trigger) return;
        if (!item.querySelector('.header__wrap__nav__link__subnav')) return;
        item.addEventListener('mouseenter', closeImmediately);
    });

    // -------------------------------------------------------
    // Make hover → switch models panel
    // -------------------------------------------------------
    panel.querySelectorAll('.mega-menu__makes__item').forEach(makeEl => {
        makeEl.addEventListener('mouseenter', () => {
            const makeId = makeEl.dataset.make;

            // Update active make
            panel.querySelectorAll('.mega-menu__makes__item').forEach(el => {
                el.classList.toggle('mega-menu__makes__item--active', el === makeEl);
            });

            // Show matching models panel
            panel.querySelectorAll('.mega-menu__models__panel').forEach(p => {
                p.classList.toggle('mega-menu__models__panel--active', p.dataset.makePanel === makeId);
            });

            // Clear active series panel when make changes
            panel.querySelectorAll('.mega-menu__series__panel').forEach(p => {
                p.classList.remove('mega-menu__series__panel--active');
            });
            panel.querySelectorAll('.mega-menu__models__panel__grid__item').forEach(el => {
                el.classList.remove('mega-menu__models__panel__grid__item--active');
            });
        });
    });

    // -------------------------------------------------------
    // Model hover → switch series panel
    // Delayed activation prevents accidental switches when the
    // mouse moves diagonally toward the series column.
    // -------------------------------------------------------
    let modelSwitchTimer = null;
    let mouseX = 0;
    let mouseY = 0;
    let prevMouseX = 0;

    panel.addEventListener('mousemove', (e) => {
        prevMouseX = mouseX;
        mouseX = e.clientX;
        mouseY = e.clientY;
    });

    const activateModel = (modelEl) => {
        const modelId = modelEl.dataset.model;

        const parentPanel = modelEl.closest('.mega-menu__models__panel');
        parentPanel.querySelectorAll('.mega-menu__models__panel__grid__item').forEach(el => {
            el.classList.toggle('mega-menu__models__panel__grid__item--active', el === modelEl);
        });

        panel.querySelectorAll('.mega-menu__series__panel').forEach(p => {
            p.classList.toggle('mega-menu__series__panel--active', p.dataset.modelPanel === modelId);
        });
    };

    panel.querySelectorAll('.mega-menu__models__panel__grid__item').forEach(modelEl => {
        modelEl.addEventListener('mouseenter', () => {
            clearTimeout(modelSwitchTimer);

            // Moving right (toward series column): long delay so diagonal
            // movement doesn't trigger a panel switch mid-travel.
            // Moving vertically (across siblings): moderate delay to prevent
            // accidental activation while skimming over adjacent items.
            const movingRight = mouseX > prevMouseX;
            const delay = movingRight ? 300 : 150;

            modelSwitchTimer = setTimeout(() => activateModel(modelEl), delay);
        });

        modelEl.addEventListener('mouseleave', () => {
            clearTimeout(modelSwitchTimer);
        });
    });

    // -------------------------------------------------------
    // Mobile: tap trigger → toggle fullscreen overlay
    // -------------------------------------------------------
    const mobilePanel = document.getElementById('mega-menu-mobile');
    if (!mobilePanel) return;

    trigger.querySelector('a').addEventListener('click', (e) => {
        if (window.innerWidth <= 1024) {
            e.preventDefault();
            mobilePanel.classList.toggle('is-open');
        }
    });

    // Mobile: accordion per make
    mobilePanel.querySelectorAll('.mega-menu-mobile__make__trigger').forEach(btn => {
        btn.addEventListener('click', () => {
            const makeEl = btn.closest('.mega-menu-mobile__make');
            const modelsEl = makeEl.querySelector('.mega-menu-mobile__make__models');
            const isOpen = makeEl.classList.contains('is-open');

            // Close all
            mobilePanel.querySelectorAll('.mega-menu-mobile__make').forEach(el => {
                el.classList.remove('is-open');
                el.querySelector('.mega-menu-mobile__make__models').style.height = '0px';
            });

            // Open clicked if it was closed
            if (!isOpen) {
                makeEl.classList.add('is-open');
                modelsEl.style.height = modelsEl.scrollHeight + 'px';
            }
        });
    });
}
